export class LocalFile {
  constructor(
   public file: File,
   public name?: string,
   public size?: number,
   public type?: string
  ) { }
}
